import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { EmailClass } from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTableLine from "../../components/atoms/TkFakeTableLine";
import TkTable from "../../components/atoms/TkTable";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkButton from "../../components/atoms/TkButton";
import { GlobalContext } from "../../context/globalContext";
import { httpAPI_TEM001 } from "./api/request";
import { mailHeadList, sendMailList } from "./parts";
import "./_style.scss";
import { TkGetCode } from "../../utils/TkGetCode";

/**
 * SCRW140001 テンプレート一覧
 * 機構職員がメールテンプレートの一覧を確認する。
 * @return SCRW140001 テンプレート一覧
 */
const SCRW140001 = () => {
  const navigate = useNavigate();

  const { state, setState } = useContext(GlobalContext);

  const [res, setRes] = useState<any>({});

  const [selected, setSelected] = useState(false);
  const [selectedClass, setSelectedClass] = useState("");
  const [headList, setHeadList] = useState<any>([]);
  const [bodyList, setBodyList] = useState<any>([]);
  const [selectValueList, setSelectValueList] = useState<any[]>([]);

  const handleCallApiInit = async () => {
    // テンプレート一覧参照API実行
    try {
      const res = await httpAPI_TEM001();

      if (res.resultCd === "I0000") {
        setRes(res);
        const selectList = res?.mailTempList!.map((item) => {
          return {
            label: TkGetCode(EmailClass, item.emailClass),
            value: item.emailClass,
          };
        });
        setSelectValueList(selectList);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleCallApiInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e: any) => {
    let tableTitle = "";
    let headList = [];
    let bodyList = [];
    if (!e) {
      setSelected(false);
      return;
    } else if (e === EmailClass["通知メール用テンプレート"]) {
      tableTitle = selectValueList.find((item) => item.value === e)!.label;
      headList = sendMailList;
      bodyList = res.mailTempList
        ?.filter((i: any) => i.emailClass === e)
        .map((item: any) => [
          {
            children: (
              <Link to="/SCRW140003" state={{ tempId: item.tempId }}>
                {item.tempName}
              </Link>
            ),
            keyword: item.tempName,
          },
          { children: item.title },
        ]);
    } else {
      tableTitle = selectValueList.find((item) => item.value === e)!.label;
      headList = mailHeadList;
      bodyList = res.mailTempList
        ?.filter((i: any) => i.emailClass === e)
        .map((item: any) => [
          {
            children: (
              <Link to="/SCRW140003" state={{ tempId: item.tempId }}>
                {item.tempName}
              </Link>
            ),
            keyword: item.tempName,
          },
          { children: item.title },
          { children: item.sendTimingKbn },
        ]);
    }

    setSelected(true);
    setSelectedClass(tableTitle);
    setHeadList(headList);
    setBodyList(bodyList);
  };

  const handleRegister = () => {
    navigate("/SCRW140002", {
      state: { emailClass: EmailClass["職員手動メール用テンプレート"] },
    });
  };

  return (
    <Box className="SCRW140001" data-testid="SCRW140001">
      <TkInfoManual>{labelids.labelid.LBLW140001_01}</TkInfoManual>
      <TkFakeTableLine
        title="メール（テンプレート）種別"
        type="selectForm"
        selectPropsList={Array.from(
          new Map(selectValueList.map((obj) => [obj.label, obj])).values()
        )}
        onChange={(e: any) => handleChange(e.target.value)}
        placeholder="選択してください"
      />

      {selected && (
        <Box className="table">
          <TkTable
            headList={headList}
            bodyList={bodyList}
            headerLeftComponent={<Typography>{selectedClass}</Typography>}
            headerRightComponent={
              selectedClass === "職員手動メール用テンプレート" && (
                <TkButton onClick={handleRegister}>新規登録</TkButton>
              )
            }
          />
        </Box>
      )}

      <Box className="button">
        <TkBackButton />
      </Box>
    </Box>
  );
};

export default SCRW140001;
